import { useToast, useDisclosure } from "@chakra-ui/react";
import constant from "config/constant";
import { useEffect, useMemo } from "react";
import { useGetUserCardDetailMutation } from "services/cardsApi";
import getError from "util/getError";

import ls from "util/secureStorage";

export default function useCardDetails(
  id,
  pin,
  input,
  resetPin = null,
  skip = false
) {
  const toast = useToast();
  const {
    isOpen: isPinOpen,
    onClose: onPinClose,
    onOpen: onPinOpen,
  } = useDisclosure();

  const [
    getCardDetails,
    {
      data,
      isLoading: isFetching,
      isSuccess,
      isError: isCardError,
      error,
      reset,
    },
  ] = useGetUserCardDetailMutation();

  const card = useMemo(() => data?.data, [data]);

  useEffect(() => {
    if (!skip && (!pin || (!!pin && pin?.length < 6))) onPinOpen();
  }, [pin, onPinOpen, skip]);

  useEffect(() => {
    if (!skip && !!pin && pin?.length === 6)
      getCardDetails({ id, pin, ...input });
    // eslint-disable-next-line
  }, [pin, skip]);

  useEffect(() => {
    if (isSuccess && card) {
      ls.set(constant.TEMP_PIN, pin);
    }

    if (isCardError && error) {
      const message = getError(error?.data?.error);
      toast({
        position: "bottom-right",
        title: "Error",
        description: message,
        status: "error",
        duration: 4000,
        isClosable: true,
      });

      if (
        String(message).toLowerCase().includes("transaction pin is incorrect")
      ) {
        reset();
        resetPin && resetPin();
        onPinOpen();
      }
    }
  }, [
    toast,
    error,
    isCardError,
    isSuccess,
    pin,
    card,
    onPinOpen,
    resetPin,
    reset,
  ]);

  return { card, isFetching, isPinOpen, onPinClose, onPinOpen, isCardError };
}
